import { React, models, kea, history, resources, selectores, componentToRx, Route, match, validation, createSelectorRx, formfields } from "app/main/std";
import { omit } from "keautils";
import { DatosFacturacion } from "./types";
import { DireccionFacturacionComponent } from "./direccionfacturacion";
import { fa } from "typed-font-awesome";
import { validarEmail } from "app/logic/cliente";

type Entity = DatosFacturacion;
export interface Props {
    value: Entity;
    tipoPersona: models.TipoPersona | null;
    readonly?: boolean;
    onChange: (value: Entity) => PromiseLike<void> | void;
}

export function validar(x: Entity, tipoPersona: models.TipoPersona | null) {

    const requeridoSiFacturacion = (value: DatosFacturacion, key: keyof DatosFacturacion) =>
        (((x.CorreoFacturacion != null && x.CorreoFacturacion != "") ||
            (x.NumeroRegistroIdentidadFiscal != null && x.NumeroRegistroIdentidadFiscal != "") ||
            (x.ResidenciaFiscal != null && x.ResidenciaFiscal != "") ||
            (x.NoCuentaOrdenante != null && x.NoCuentaOrdenante != "") ||
            (tipoPersona == models.TipoPersona.Moral))
            && x[key] == null) ? "Requerido si se establecen valores de facturación" : true;

    const rules: validation.Rules<Entity> = {
        CodigoRegimenFiscal: validation.required,
        NombreFiscal: validation.required
    };

    return validation.getErrors(rules, x);
}

/**
* Componente para editar un DatosFacturacion
*/
export class DatosFacturacionComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    tipoPersona = (props: Props) => props.tipoPersona;
    errors = createSelectorRx(this.value, this.tipoPersona, (x, tipoPersona) => validar(x, tipoPersona));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    arregloCadena = (props: Props) => props.value.CorreoFacturacion ? props.value.CorreoFacturacion.split(";") : [];
    arregloCorreos = createSelectorRx(this.arregloCadena, arreglo => arreglo.filter(x => x != undefined && x != "").map(x => ({ valido: validarEmail(x), correo: x })));

    onEliminarCorreo = async (index: number) => {
        const value = this.props.value;
        const arregloCorreos = this.arregloCorreos(this.props);
        var arreglos = arregloCorreos.filter((x, i) => index != i);
        const nuevoValueCorreo = arreglos.map(x => x.correo).join(";");
        const cambio: Partial<Entity> = { CorreoFacturacion: nuevoValueCorreo };
        await this.props.onChange({ ...value, ...cambio });
    }

    render() {
        const { value, onChange } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);
        const FormaPago = getField(selectores.ClaveFormaPagoSat);
        const MetodoPago = getField(selectores.ClaveMetodoPagoSat);

        const CodigoRegimenFiscal = getField(selectores.CodigoRegimenFiscal);


        const arregloCorreos = this.arregloCorreos(this.props);

        return (
            <div>
                {kea.autogrid(6, [
                    <div>
                        <p><strong>Correo de facturación</strong></p>
                        {
                            arregloCorreos.map((x, i) => <span style={{ color: "black", backgroundColor: x.valido ? "#E3FBCA" : "#FBD2CA" }} className="badge">{x.correo} {' '} <kea.IconButton onClick={() => this.onEliminarCorreo(i)} style="danger" iconClass={fa("times")} />  </span>)
                        }
                        <Text field="CorreoFacturacion" label="" />
                    </div>,
                    <Text field="NumeroRegistroIdentidadFiscal" label="Número registro de identidad fiscal" />,
                    <Text field="ResidenciaFiscal" label="Codigo postal domicilio fiscal" />,
                    <Text field="NoCuentaOrdenante" label="No. Cuenta ordenante" />,
                    <CodigoRegimenFiscal field="CodigoRegimenFiscal" label="Regimen Fiscal" />,
                    <Text field="NombreFiscal" label="Nombre fiscal" />,


                ])}
                <div className="row">
                    <div className="col-md-12">
                        <Check field="CoparDireccionCatalogo" label="Agregar direccion en catalogo"  value={value.CoparDireccionCatalogo}/>
                        <DireccionFacturacionComponent value={value} onChange={onChange} />
                    </div>
                </div>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/clientes/edit/componentes/datosfacturacion.tsx